module.exports = __webpack_public_path__ + "images/code.fac67a6.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/activities/icon/code.png
// module id = 633
// module chunks = 0